"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EMITTED = exports.PROCESSING_EMISSION = exports.PENDING_EMISSION = exports.PENDING_INSPECTION = void 0;
exports.PENDING_INSPECTION = 1;
exports.PENDING_EMISSION = 2;
exports.PROCESSING_EMISSION = 3;
exports.EMITTED = 4;
//# sourceMappingURL=quotationStatus.js.map